export const isProd = process.env.VITE_APP_ENV === 'prod';
export const isDev = process.env.VITE_APP_ENV === 'dev';
export const isLocal = process.env.VITE_APP_ENV === 'local';
export const isDemo = process.env.VITE_APP_ENV === 'demo';
export const isTest = process.env.VITE_APP_ENV === 'test';
export enum Environment {
    PROD = 'prod',
    DEV = 'dev',
    LOCAL = 'local',
    DEMO = 'demo',
    TEST = 'stage'
}
